module.exports = __webpack_public_path__ + "media/images/interstitial/train-b1d2b1ec77236edbec5938db0f2aa293.svg";